module.exports = __webpack_public_path__ + "img/icon-warning.d684ade2.png";